module.exports = "/images/bell.svg?145995224dbbf73b5c222b1cbd93bde7";